module Meevo.Components.Controls.SmartMover {
    import Manufacturer = Model.Manufacturer;

    export class ProductVariantToManufacturerStrategy implements ICollectionPopulate {
        constructor(private parent: ICollectionBase<Model.Manufacturer>, private child: ICollectionBase<Model.Variant>) {
        }

        populate(): void {
            const groups = _.groupBy(this.child.models, variant => variant.get('manufacturerId') + '_' + variant.get('categoryId'));
            for (const man of this.parent.models) {
                const key = man.get('id') + '_' + man.get('categoryId');
                const variants = groups[key] || [];
                (<ISmartMoverCategoryModel<Model.Manufacturer>>man).resetModels(variants);
            }
        }
    }
}